import { TCDATA_READY } from '../store/modules/consentManagement'
import { combineEpics, ofType } from 'redux-observable'
import { map, take } from 'rxjs'
import { logObservableError } from '../utilities/logs'
import { initialized } from '../store/modules/truvid'

// initEpic :: Epic -> Observable Action.INITIALIZED
export const initEpic = (action$, _, { logger }) =>
  action$.pipe(
    ofType(TCDATA_READY),
    take(1),
    map(initialized),
    logObservableError('truvid :: initEpic', logger),
  )

export default combineEpics(initEpic)
